<template>
  <div class="d-flex flex-column align-center mb-10 px-1 px-sm-4">
    <CustomScenarioChart :period="otherValues.lifeExpectancy" category="age" />


    <div class="small-text-font mt-12 mb-4">
      Your equity right now is approximately
      <span class="font-weight-bold">{{
        formatMoney(tableValues.finalValuesByNow.homeEquity)
        }}</span>. If your property value increases by approximately
      <span class="font-weight-bold">{{
        formatPercentage(selectedValues.propertyValueApreciationRate)
        }}</span>
        each year for the next
        <span class="font-weight-bold">{{ currentEffectiveYear }}</span> years, your equity in
        <span class="font-weight-bold">{{ currentEffectiveYear }}</span> years will be about:
        <span class="font-weight-bold">{{
          formatMoney(tableValues.finalValuesByYears.homeEquity)
        }}</span>
      .......without making any mortgage payments.
    </div>

    <CustomPropertValueAppreciationRatesTable />

    <NowVsFutureTableCDE finalRowLabel="Equity Change + Cash Savings" preFinalRowLabel="Estimated Cash Flow Savings"
      :preFinalRowValue="estimatedTotalCashFlowSavings" />

  </div>
</template>

<script>
// import InterestRateScenarioChart from '../../Charts/InterestRateScenarioChart.vue';
// import InterestRateScenarioSelector from '../../Selectors/InterestRateScenarioSelector.vue';
// import CustomInterestRatesTable from '../../Tables/CustomInterestRatesTable.vue';
import NowVsFutureTableCDE from '../../Tables/NowVsFutureTableCDE.vue';
import CustomScenarioChart from '../../Charts/CustomScenarioChart.vue';
import CustomPropertValueAppreciationRatesTable from '../../Tables/CustomPropertValueAppreciationRatesTable.vue';

import helpers from '../../../helpers';

export default {
  components: {
    // CustomInterestRatesTable,
    // InterestRateScenarioSelector,
    // InterestRateScenarioChart,
    NowVsFutureTableCDE,
    CustomScenarioChart,
    CustomPropertValueAppreciationRatesTable
  },
  computed: {
    tableValues() {
      return this.$store.state.scenarioData.currentScenarioData.finalValues.tableValues;
    },
    selectedValues() {
      return this.$store.state.scenarioData.currentScenarioData.selectsOptions.selected;
    },
    otherValues() {
      return this.$store.state.scenarioData.currentScenarioData.finalValues.otherValues;
    },
    estimatedTotalCashFlowSavings() {
      return this.$store.state.scenarioData.currentScenarioData.finalValues.tableValues
        .estimatedTotalCashFlowSavings;
    },
    currentEffectiveYear() {
      return this.$store.state.scenarioData.currentScenarioData.selectsOptions.selected
        .effectiveAge;
    }
  },
  methods: {
    formatMoney: helpers.formatMoney,
    formatPercentage: helpers.formatPercentage
  }
};
</script>

<style scoped></style>
